
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import bsDescriptor from '../../MetawebBusinessModelDescriptor.json'

export default defineComponent({
    components: { DataTable, Column, KnValidationMessages },
    props: { physicalModels: Array, showBusinessViewDialog: Boolean, bnssViewObject: Object },
    data() {
        return {
            bsDescriptor,
            v$: useValidate() as any,
            tmpBnssView: {} as any,
            filters: {
                global: [filterDefault]
            } as Object
        }
    },
    created() {
        this.tmpBnssView = this.bnssViewObject
    },
    watch: {
        bnssViewObject() {
            this.tmpBnssView = this.bnssViewObject
        }
    },
    validations() {
        const bvRequired = (value) => {
            return !this.showBusinessViewDialog || value
        }
        const customValidators: ICustomValidatorMap = {
            'bv-dialog-required': bvRequired
        }
        const validationObject = {
            tmpBnssView: createValidations('tmpBnssView', bsDescriptor.validations.tmpBnssView, customValidators)
        }
        return validationObject
    }
})
